'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  position: relative;\n  border: ', ';\n  border-radius: ', ';\n  background-color: ', ';\n  height: 40px;\n  text-align: ', ';\n  cursor: pointer;\n\n  &:hover {\n    border: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  position: relative;\n  border: ', ';\n  border-radius: ', ';\n  background-color: ', ';\n  height: 40px;\n  text-align: ', ';\n  cursor: pointer;\n\n  &:hover {\n    border: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      border-color: ', ';\n      background-color: ', ';\n    '], ['\n      border-color: ', ';\n      background-color: ', ';\n    ']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      border: ', ';\n      cursor: default;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    '], ['\n      background-color: ', ';\n      border: ', ';\n      cursor: default;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    ']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      border: ', ';\n      cursor: not-allowed;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    '], ['\n      background-color: ', ';\n      border: ', ';\n      cursor: not-allowed;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    ']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  transform: rotate(90deg);\n\n  ', ';\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  transform: rotate(90deg);\n\n  ', ';\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['transform: rotate(-90deg);'], ['transform: rotate(-90deg);']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 28px;\n  width: 28px;\n  background-color: ', ';\n  border-radius: ', ';\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 28px;\n  width: 28px;\n  background-color: ', ';\n  border-radius: ', ';\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: 4px;\n  background: ', ';\n  width: 100%;\n  display: none;\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 0px;\n  z-index: 300;\n  border: 1px solid ', ';\n  box-shadow: 0 3px 6px rgba(140, 140, 140, 0.08);\n\n  ', ';\n'], ['\n  border-radius: 4px;\n  background: ', ';\n  width: 100%;\n  display: none;\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 0px;\n  z-index: 300;\n  border: 1px solid ', ';\n  box-shadow: 0 3px 6px rgba(140, 140, 140, 0.08);\n\n  ', ';\n']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n      display: block;\n      width: calc(100% + 2px);\n      left: -1px;\n      top: calc(100% + 4px);\n      min-height: 200px;\n    '], ['\n      display: block;\n      width: calc(100% + 2px);\n      left: -1px;\n      top: calc(100% + 4px);\n      min-height: 200px;\n    ']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 8px 16px;\n  cursor: pointer;\n\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border-radius: 0;\n    border: none;\n  }\n\n  ', ';\n'], ['\n  padding: 8px 16px;\n  cursor: pointer;\n\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border-radius: 0;\n    border: none;\n  }\n\n  ', ';\n']),
    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n      color: ', ';\n      background: ', ';\n      border-radius: 0;\n      border: none;\n    '], ['\n      color: ', ';\n      background: ', ';\n      border-radius: 0;\n      border: none;\n    ']),
    _templateObject12 = (0, _taggedTemplateLiteral3.default)(['\n  transition: all 0.15s linear;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 10px;\n  height: 40px;\n'], ['\n  transition: all 0.15s linear;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 10px;\n  height: 40px;\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _layout = require('../layout');

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledSelect = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Block)(_templateObject, function (props) {
  return props.theme.input.inputDefaultBorder;
}, function (props) {
  return props.theme.input.inputBorderRadius;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.center ? 'center' : 'left';
}, function (props) {
  return props.theme.input.inputHoverBorder;
}, function (props) {
  return props.open && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.grey500, props.theme.colors.grey200);
}, function (props) {
  return props.readonly && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject3, props.theme.input.inputReadonlyBackground, props.theme.input.inputReadonlyBorder, props.theme.input.inputReadonlyColor, props.theme.input.inputReadonlyBorder);
}, function (props) {
  return props.disabled && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject4, props.theme.input.inputDisabledBackground, props.theme.input.inputDisabledBorder, props.theme.input.inputDisabledColor, props.theme.input.inputDisabledBorder);
});

var StyledIconChevron = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject5, function (props) {
  return props.open && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject6);
});

var StyledIconClear = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject7, function (props) {
  return props.theme.colors.grey300;
}, function (props) {
  return props.theme.layout.borderRadius;
});

var StyledSelectOptions = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject8, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grey400;
}, function (props) {
  return props.open && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject9);
});

var StyledOption = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject10, function (props) {
  return props.theme.colors.navy700;
}, function (props) {
  return props.theme.colors.grey300;
}, function (props) {
  return props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject11, props.theme.colors.navy700, props.theme.colors.grey300);
});

var StyledSelectSelected = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject12);
/**
 * The kalo generic select component
 */

var Select = function (_PureComponent) {
  (0, _inherits3.default)(Select, _PureComponent);

  function Select(props) {
    (0, _classCallCheck3.default)(this, Select);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.state = {
      open: false
    };

    _this.onToggle = _this.onToggle.bind(_this);
    _this.onSelect = _this.onSelect.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.onClear = _this.onClear.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Select, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onClose);
    }
  }, {
    key: 'open',
    value: function open() {
      var _this2 = this;

      setTimeout(function () {
        return window.addEventListener('click', _this2.onClose);
      }, 300);
      this.setState({ open: true });
    }
  }, {
    key: 'close',
    value: function close() {
      window.removeEventListener('click', this.onClose);
      this.setState({ open: false });
      if (this.props.onBlur) this.props.onBlur();
    }
  }, {
    key: 'onToggle',
    value: function onToggle() {
      if (this.props.readonly) return;
      if (this.state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.close();
    }
  }, {
    key: 'onClear',
    value: function onClear(event) {
      this.props.onSelect(undefined);
      this.close();
      event.stopPropagation();
    }
  }, {
    key: 'onSelect',
    value: function onSelect(value) {
      this.props.onSelect(value);
      this.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          selection = _props.selection,
          placeholder = _props.placeholder,
          nullable = _props.nullable,
          formatSelection = _props.formatSelection,
          readonly = _props.readonly,
          empty = _props.empty,
          disabled = _props.disabled,
          _IGNORED = _props.editable,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'selection', 'placeholder', 'nullable', 'formatSelection', 'readonly', 'empty', 'disabled', 'editable']);
      var open = this.state.open;


      return React.createElement(
        StyledSelect,
        (0, _extends3.default)({
          readonly: readonly,
          disabled: disabled,
          open: open
        }, otherProps),
        React.createElement(
          StyledSelectSelected,
          {
            onClick: readonly || disabled ? undefined : this.onToggle
          },
          !!selection ? React.createElement(
            _text2.default,
            {
              color: readonly || disabled ? 'navy500' : 'navy700',
              weight: 'normal'
            },
            formatSelection(selection)
          ) : React.createElement(
            _text2.default,
            {
              color: readonly || disabled ? 'navy500' : 'navy700',
              weight: 'normal'
            },
            placeholder
          ),
          (!readonly || !disabled) && !!selection && nullable ? React.createElement(
            StyledIconClear,
            null,
            React.createElement(
              _icon2.default,
              {
                size: 18,
                onClick: this.onClear,
                color: readonly || disabled ? 'grey500' : 'navy700'
              },
              'clear'
            )
          ) : null,
          (!readonly || !disabled) && (!selection || !nullable) ? React.createElement(
            StyledIconChevron,
            { open: open },
            React.createElement(
              _icon2.default,
              {
                color: readonly || disabled ? 'grey500' : 'navy700',
                size: 24
              },
              'chevron_right'
            )
          ) : null
        ),
        React.createElement(
          StyledSelectOptions,
          {
            open: open,
            onClick: function onClick(event) {
              return event.stopPropagation();
            }
          },
          React.Children.map(children, function (child) {
            return child ? React.createElement(
              StyledOption,
              {
                key: child.key,
                name: child.key,
                selected: child.props.selected,
                onClick: function onClick() {
                  return _this3.onSelect(child.props.value);
                }
              },
              child
            ) : null;
          }),
          !React.Children.count(children) ? React.createElement(
            _text2.default,
            null,
            empty
          ) : null
        )
      );
    }
  }]);
  return Select;
}(_component2.default);

Select.defaultProps = {
  onSelect: function onSelect() {},
  center: false,
  placeholder: 'Select…',
  empty: 'No items',
  nullable: true,
  formatSelection: function formatSelection(selection) {
    return selection;
  },
  readonly: false,
  disabled: false
};
exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/select/select.js
// module id = 351
// module chunks = 114276838955818